//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.Dialogs.ts						</Name>
//    <Description> Volání Adm dialogů							</Description>
//    <Author>      Tomáš Hažmuka								</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018			</Copyright>
//    <Created>     2018-11-07                                  </Created>
//  </FileHeader>

namespace Gordic.Adm.Dialogs {

//---------------------------DETAIL
    export function DetailStupenSchvaleniEpkDlg(
		parentContent: GContent,
		opt: {
            /** stav_schvproc */
            stav_schvproc: number | null,
			/** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
		},
		ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
	): JQueryPromise<undefined> {

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
		ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;
		var detailCommand = opt.grid ? false : true;

		// grid remote control, kvůli šipkám na detailu
		const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailStupenSchvaleniEpk', { gridRemoteControl: gridRemoteControl }]

		const options = {
            ID: "AdmDetailStupnuSchvaleniEpk#",
            stav_schvproc: opt ? opt.stav_schvproc : undefined,
            newRecord: opt ? opt.newRecord : undefined,
			detailCommand: detailCommand
		};

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options); 
		} else {
			deferred.reject();
		}

		return deferred.promise();
	}

    export function DetailSchvalovaciRoleEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_sro */
            ixs_sro: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailSchvalovaciRoleEpk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmDetailSchvalovaciRoleEpk#",
            ixs_sro: opt ? opt.ixs_sro : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // FunkceSchvalovaciRoleEpk
    export function DetailFunkceSchvalovaciRoleEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_fun */
            ixs_fun: string | null,
            /** ixs_sro */
            ixs_sro: string | null,
            /** dat_od */
            dat_od: Date | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailFunkceSchvalovaciRoleEpk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmDetailFunkceSchvalovaciRoleEpk#",
            ixs_fun: opt ? opt.ixs_fun : undefined,
            ixs_sro: opt ? opt.ixs_sro : undefined,
            dat_od: opt ? opt.dat_od : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // FunkceSchvalovaciSablonyEpk
    export function DetailFunkceSchvalovaciSablonyEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_fun */
            ixs_fun: string | null,
            /** ixs_ssa */
            ixs_ssa: string | null,
            /** ixs_sro */
            ixs_sro: string | null,
            /** dat_od */
            dat_od: Date | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailFunkceSchvalovaciSablonyEpk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmFunkceSchvalovaciSablonyEpk#",
            ixs_fun: opt ? opt.ixs_fun : undefined,
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
            ixs_sro: opt ? opt.ixs_sro : undefined,
            dat_od: opt ? opt.dat_od : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // FunkceSchvalovaciSablonyEpk
    export function DetailTypyDokumentuSchvalovaciSablonyEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ssa */
            ixs_ssa: string | null,
            /** ixs_typ */
            ixs_typ: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailTypyDokumentuSchvalovaciSablonyEpk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmTypyDokumentuSchvalovaciSablonyEpk#",
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
            ixs_typ: opt ? opt.ixs_typ : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // SchvalovaciSablonaEpkUkony
    export function DetailSchvalovaciSablonaEpkUkonyDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ssa */
            ixs_ssa: string | null,
            /** radek_sab */
            radek_sab: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailSchvalovaciSablonaEpkUkony', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmSchvalovaciSablonaEpkUkony#",
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
            radek_sab: opt ? opt.radek_sab : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // FunkceSchvalovaciSablonyEpk
    export function DetailGrafDefiniceDlg(
        parentContent: GContent,
        opt: {
            /** ixs_grf */
            ixs_grf: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailGrafDefinice', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmGrafDefinice#",
            ixs_grf: opt ? opt.ixs_grf : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // FunkceSchvalovaciSablonyEpk
    export function DetailFormularSkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_fsk */
            ixs_fsk: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailFormularSk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmFormularSk#",
            ixs_fsk: opt ? opt.ixs_fsk : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // FunkceSchvalovaciSablonyEpk
    export function DetailKonfiguraceDrmsDlg(
        parentContent: GContent,
        opt: {
            /** jeden */
            jeden: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailKonfiguraceDrms', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmKonfiguraceDrms#",
            jeden: opt ? opt.jeden : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }





//---------------------------SEZNAM
    // SchvalovaciSablonaEpk
    export function DetailSeznamSchvalovaciSablonaEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ssa - PK */
            ixs_ssa: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailSchvalovaciSablonaEpk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmDetailSchvalovaciSablonaEpk#",
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // FunkceSchvalovaciRoleEpk
    export function SeznamFunkceSchvalovaciRoleEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_sro */
            ixs_sro: string | null
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamFunkceSchvalovaciRoleEpk', { }]

        const options = {
            ID: "AdmSeznamFunkceSchvalovaciRoleEpk#",
            ixs_sro: opt ? opt.ixs_sro : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }
    
    // FunkceSchvalovaciSablonyEpk
    export function SeznamFunkceSchvalovaciSablonyEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ssa */
            ixs_ssa: string | null
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamFunkceSchvalovaciSablonyEpk', {}]

        const options = {
            ID: "AdmFunkceSchvalovaciSablonyEpk#",
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // TypyDokumentuSchvalovaciSablonyEpk
    export function SeznamTypyDokumentuSchvalovaciSablonyEpkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ssa */
            ixs_ssa: string | null
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamTypyDokumentuSchvalovaciSablonyEpk', {}]

        const options = {
            ID: "AdmTypyDokumentuSchvalovaciSablonyEpk#",
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // SchvalovaciSablonaEpkUkony
    export function SeznamSchvalovaciSablonaEpkUkonyDlg(
        parentContent: GContent,
        opt: {
            /** ixs_ssa */
            ixs_ssa: string | null
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamSchvalovaciSablonaEpkUkony', {}]

        const options = {
            ID: "AdmSchvalovaciSablonaEpkUkony#",
            ixs_ssa: opt ? opt.ixs_ssa : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // GrafObsah
    export function SeznamGrafObsahDlg(
        parentContent: GContent,
        opt: {
            /** ixs_grf */
            ixs_grf: string | null,
            data: Gordic.AdmIsl.Interface.GGrafDefiniceDto
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamGrafObsah', {}]

        const options = {
            ID: "AdmSeznamGrafObsah#",
            ixs_grf: opt ? opt.ixs_grf : undefined,
            data: opt ? opt.data : undefined
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    // FormularSk
    export function SeznamFormularSkDlg(
        parentContent: GContent,
        opt: {
            /** ixs_fsk */
            ixs_fsk: string | null,
            data: Gordic.AdmIsl.Interface.GFormularSkDto
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamFormularSk', {}]

        const options = {
            ID: "AdmSeznamFormularSk#",
            ixs_fsk: opt ? opt.ixs_fsk : undefined,
            data: opt ? opt.data : undefined
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    //------------------------------- EleServer
    // EleServer
    export function DetailEleServerDlg(
        parentContent: GContent,
        opt: {
            /** server_name */
            server_name: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailEleServer', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmEleServer#",
            server_name: opt ? opt.server_name : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // EleServer
    export function SeznamEleServerDlg(
        parentContent: GContent,
        opt: {
            /** server_name */
            server_name: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamEleServer', {}]

        const options = {
            ID: "AdmEleServer#",
            server_name: opt ? opt.server_name : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }
    //------------------------------- EleServerDisk
    // EleServerDisk
    export function DetailEleServerDiskDlg(
        parentContent: GContent,
        opt: {
            /** server_name */
            server_name: string | null,
            /** disk_name */
            disk_name: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** příznak nového záznamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        var detailCommand = opt.grid ? false : true;

        // grid remote control, kvůli šipkám na detailu
        const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

        var detail = ['Gordic.Adm.WebControls.DetailEleServerDisk', { gridRemoteControl: gridRemoteControl }]

        const options = {
            ID: "AdmEleServerDisk#",
            server_name: opt ? opt.server_name : undefined,
            disk_name: opt ? opt.disk_name : undefined,
            newRecord: opt ? opt.newRecord : undefined,
            detailCommand: detailCommand
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    // EleServerDisk
    export function SeznamEleServerDiskDlg(
        parentContent: GContent,
        opt: {
            /** server_name - nepovinný vstupní argument - filtrační podmínka pro seznam */
            server_name?: string | null,
            /** disk_name - nepovinný vstupní argument - filtrační podmínka pro seznam */
            disk_name?: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        var detail = ['Gordic.Adm.WebControls.SeznamEleServerDisk', {}]

        const options = {
            ID: "AdmEleServerDisk#",
            server_name: opt ? opt.server_name : undefined,
            disk_name: opt ? opt.disk_name : undefined,
        };

        if (isValid) {
            //RC 32131033 : Detail
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }
}
